import { render, staticRenderFns } from "./ArchivoAdjuntoCasoView.vue?vue&type=template&id=1bcea172"
import script from "./ArchivoAdjuntoCasoView.vue?vue&type=script&lang=js"
export * from "./ArchivoAdjuntoCasoView.vue?vue&type=script&lang=js"
import style0 from "./ArchivoAdjuntoCasoView.vue?vue&type=style&index=0&id=1bcea172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports